import axios from 'axios';

import { getData } from '@feature/utils';

import { PublicationReclaimSearch, PublicationSearchRequest } from './PublicationTypes';

export function searchByIdentifiers(request: PublicationSearchRequest) {
  return axios
    .get<PublicationReclaimSearch>('/author/publications/search/by-id', {
      params: {
        ...request,
      },
    })
    .then(getData);
}

export function reclaimAuthorship(publicationId: number, authorId: number) {
  return axios.post<unknown>(`/author/publications/${publicationId}/reclaim-authorship/${authorId}`).then(getData);
}
